import $ from 'jquery';
import { scrollToElement } from '../lib/utilities';
import { getUrlHash } from '../lib/utilities';

$(() => {
  if ($('.side-nav a').length > 0) {
    function highlightSideNav() {
      $('.side-nav a').each(function () {
        if (getUrlHash() === $(this).attr('href')) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
    }

    highlightSideNav();

    $('.side-nav a').on('click', function (event) {
      let $id = event.target.href.substring(
        event.target.href.lastIndexOf('/') + 1
      );
      scrollToElement($id);
      location.hash = $id;
      highlightSideNav();
    });
  }
});
